import { Dropdown, Button } from "antd";
import { EditOutlined, DownOutlined } from "@ant-design/icons";
import { BulkUpdateActionType } from "./BulkUpdateModalConfig";

const BulkUpdateActionMenu = ({
  disabled,
  count,
  onSelect,
  size = "small",
}) => {
  const items = [
    { key: BulkUpdateActionType.ASSIGNEE, label: "Assign Agent" },
    { key: BulkUpdateActionType.PRODUCER_1, label: "Update Producer Code 1" },
    { key: BulkUpdateActionType.PRODUCER_2, label: "Update Producer Code 2" },
  ];

  return (
    <Dropdown
      trigger={["hover"]}
      disabled={disabled}
      menu={{
        items,
        onClick: ({ key }) => onSelect(key),
      }}
    >
      <Button type="primary" size={size} disabled={disabled}>
        <EditOutlined />
        {`Bulk Update ${count ? `(${count})` : ""}`}
        <DownOutlined style={{ marginLeft: 4 }} />
      </Button>
    </Dropdown>
  );
};

export default BulkUpdateActionMenu;
